export const GET_REPORTS_LIST = 'GET_REPORTS_LIST';
export const UPDATE_REPORTS_ACTIVE = 'UPDATE_REPORTS_ACTIVE';
export const UPDATE_FILTER_REPORTS = 'UPDATE_FILTER_REPORTS';
export const GET_REPORTS_OF_CODE = 'GET_REPORTS_OF_CODE';
export const UPDATE_FILTER_REPORTS_ARR = 'UPDATE_FILTER_REPORTS_ARR';